import React, { useEffect, useState, useContext } from "react";
import { useParams, useHistory } from "react-router-dom";
import Input from "../../shared/components/formElements/Input";
import Button from "../../shared/components/formElements/Button";
import Card from "../../shared/components/UIElements/Card";
import LoadingSpinner from "../../shared/components/UIElements/LoadingSpinner";
import ErrorModal from "../../shared/components/UIElements/ErrorModal";
import {
  VALIDATOR_MAXLENGTH,
  VALIDATOR_NOT_REQUIRE,
  VALIDATOR_REQUIRE,
  VALIDATOR_NUMERIC,
  VALIDATOR_SPECIAL_CHARACHTER,
  VALIDATOR_MINLENGTH,
} from "../../shared/util/validators";
import { useForm } from "../../shared/hooks/form-hook";
import { useHttpClient } from "../../shared/hooks/http-hook";
import { AuthContext } from "../../shared/context/auth-context";
import "./Alterations.css";
import "./AlterationInfo.css";
import Toggle from "../../shared/components/formElements/Toggle";

const UpdateAlteration = () => {
  const auth = useContext(AuthContext);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();
  const [loadedAlteration, setLoadedAlteration] = useState();
  const alterationID = useParams().alterationId;
  const history = useHistory();

  const [formState, inputHandler, setFormData] = useForm(
    {
      orderNumber: {
        value: "",
        isValid: false,
      },
      customerName: {
        value: "",
        isValid: false,
      },
      phone: {
        value: "",
        isValid: false,
      },
      orders: {
        value: [],
        isValid: false,
      },
      date: {
        value: "",
        isValid: true,
      },
      dueDate: {
        value: "",
        isValid: true,
      },
      salesTax: {
        value: "",
        isValid: false,
      },
      description: {
        value: "",
        isValid: true,
      },
    },
    false
  );
  let responseData;
  useEffect(() => {
    const fetchAlteration = async () => {
      try {
        responseData = await sendRequest(
          process.env.REACT_APP_BACKEND_URL + `/alterations/${alterationID}`,
          "GET",
          null,
          { Authorization: "Bearer " + auth.token }
        );
        setLoadedAlteration(responseData.alteration);
        setFormData(
          {
            orderNumber: {
              value: responseData.alteration.orderNumber,
              isValid: true,
            },
            customerName: {
              value: responseData.alteration.customerName,
              isValid: true,
            },
            phone: {
              value: responseData.alteration.phone,
              isValid: true,
            },
            orders: {
              value: responseData.alteration.orders,
              isValid: true,
            },
            date: {
              value: responseData.alteration.date,
              isValid: true,
            },
            dueDate: {
              value: responseData.alteration.dueDate,
              isValid: true,
            },
            salesTax: {
              value: responseData.alteration.salesTax,
              isValid: true,
            },
            description: {
              value: responseData.alteration.description,
              isValid: true,
            },
          },
          true
        );
      } catch (err) {}
    };
    fetchAlteration();
  }, [sendRequest, alterationID, setFormData, auth.token]);
  const placeUpdateSubmitHandler = async (event) => {
    event.preventDefault();
    try {
      await sendRequest(
        process.env.REACT_APP_BACKEND_URL + `/alterations/${alterationID}/edit`,
        "PATCH",
        JSON.stringify({
          customerName: formState.inputs.customerName.value.toUpperCase(),
          phone: formState.inputs.phone.value,
          date: formState.inputs.date.value,
          // orders: responseData.alteration.orders,
          dueDate: formState.inputs.dueDate.value + "T00:00:00.000Z",
          salesTax: formState.inputs.salesTax.value,
          description: formState.inputs.description.value,
        }),
        {
          "Content-Type": "application/json",
          Authorization: "Bearer " + auth.token,
        }
      );
      history.push(`/alterations/${alterationID}`);
    } catch (err) {}
  };
  if (isLoading) {
    return (
      <div className="center">
        <LoadingSpinner />
      </div>
    );
  }
  if (!loadedAlteration && !error) {
    return (
      <div className="center">
        <Card>
          <h2>Could not find the alteration !</h2>
        </Card>
      </div>
    );
  }

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError} />
      {!isLoading && loadedAlteration && (
        <div className="alteration-list">
          <Card className="alteration-item__content">
            <h2 className="alteration-header-text">Edit Alteration</h2>

            <div className="flex justify-around ">
              <div className="w-30 m2">
                <label>Order Number</label>
                <input
                  readOnly
                  type="text"
                  value={loadedAlteration.orderNumber}
                />
              </div>

              <div className=" w-30 ml2">
                <label>Start Date</label>
                <input
                  readOnly
                  type="text"
                  value={loadedAlteration.date.substring(0, 10)}
                />
              </div>

              <div className="w-30 alt-due-date">
                <label>Due Date</label>
                <Input
                  id="dueDate"
                  element="input"
                  type="date"
                  validators={[VALIDATOR_REQUIRE()]}
                  errorText="Please enter a Due Date."
                  onInput={inputHandler}
                  initialValue={formState.inputs.dueDate.value.split("T")[0]}
                  initialValid={formState.inputs.dueDate.isValid}
                />
              </div>
            </div>
            <form
              className="alteration-form"
              onSubmit={placeUpdateSubmitHandler}
            >
              <div className="flex justify-around">
                <div className="w-50 m2 ph2">
                  <Input
                    id="customerName"
                    element="input"
                    type="text"
                    label="Customer Name"
                    validators={[
                      VALIDATOR_REQUIRE(),
                      VALIDATOR_SPECIAL_CHARACHTER(),
                    ]}
                    errorText="Please enter a valid customer name."
                    onInput={inputHandler}
                    initialValue={formState.inputs.customerName.value}
                    initialValid={formState.inputs.customerName.isValid}
                  />
                </div>
                <div className="w-50 m2 ph2">
                  <Input
                    id="phone"
                    element="input"
                    type="text"
                    label="Phone"
                    validators={[
                      VALIDATOR_SPECIAL_CHARACHTER(),
                      VALIDATOR_MINLENGTH(10),
                      VALIDATOR_MAXLENGTH(10),
                      VALIDATOR_NUMERIC(),
                    ]}
                    errorText="Please enter a valid phone."
                    onInput={inputHandler}
                    initialValue={formState.inputs.phone.value}
                    initialValid={formState.inputs.phone.isValid}
                  />
                </div>
              </div>
              <div className="flex justify-around ">
                <div className=" w-100 mh1">
                  <Input
                    id="description"
                    element="input"
                    type="text"
                    label="Description"
                    validators={[
                      VALIDATOR_NOT_REQUIRE(),
                      VALIDATOR_SPECIAL_CHARACHTER(),
                    ]}
                    errorText="Please enter a valid description."
                    onInput={inputHandler}
                    initialValue={formState.inputs.description.value}
                    initialValid={formState.inputs.description.isValid}
                  />
                </div>
                <div className="w-100 mh1">
                  <div style={{ marginTop: "41px" }}>
                    <Toggle
                      label="Sales Tax"
                      onInput={inputHandler}
                      id="salesTax"
                      // initialState={responseData.alteration.salesTax}
                      initialState={formState.inputs.salesTax.value}
                    />
                  </div>
                </div>
              </div>

              <Button type="submit" disabled={!formState.isValid}>
                UPDATE
              </Button>
              <Button inverse to={`/alterations/${alterationID}`}>
                CANCEL
              </Button>
            </form>
          </Card>
        </div>
      )}
    </React.Fragment>
  );
};

export default UpdateAlteration;
